import { CANONICAL_AI_ENGINEERING_COURSE_ID } from './course-id.aliases';

export const PRIMARY_COURSE_ID = CANONICAL_AI_ENGINEERING_COURSE_ID;
export const PRIMARY_COURSE_TITLE = 'AI Engineering mit Vibe Coding und Agentic AI';

export const COURSE_INFO_LINKS = [
  { label: 'Impressum', labelEn: 'Legal notice', href: 'https://www.knoot-academy.de/impressum' },
  { label: 'Datenschutz', labelEn: 'Privacy policy', href: 'https://www.knoot-academy.de/datenschutz' },
  { label: 'AGB', labelEn: 'Terms & conditions', href: 'https://www.knoot-academy.de/agb' },
  { label: 'Kontakt', labelEn: 'Contact', href: 'https://www.knoot-academy.de/kontakt' },
] as const;
